import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { UUID } from '@/types';
import { Invitation } from '@/features/dashboardShare/ShareDropdown/InviteTab/InvitedUsers';
import { csrfToken } from '@/util/helpers/ajax-helpers';

export const inviteApi = createApi({
  reducerPath: 'inviteDataApi',
  tagTypes: ['users'],
  baseQuery: fetchBaseQuery({
    baseUrl: '/',
    credentials: 'same-origin',
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json;charset=UTF-8');
      headers.set('x-requested-with', 'XMLHttpRequest');

      const token = csrfToken();
      if (token) headers.set('x-csrf-token', token);

      return headers;
    },
  }),
  endpoints: (builder) => ({
    getInvites: builder.query<
      string[],
      { datasourceId: UUID; dashboardId: UUID }
    >({
      query: ({ datasourceId, dashboardId }) =>
        `datasources/${datasourceId}/permissions/getAll/${dashboardId}`,
      providesTags: ['users'],
    }),
    sendInvitation: builder.mutation<Invitation, Invitation>({
      query(body: Invitation) {
        return {
          url: `/datasources/${body.datasourceId}/permissions/grant`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['users'],
    }),
    revokeInvitation: builder.mutation<Invitation, Invitation>({
      query(body: Invitation) {
        return {
          url: `/datasources/${body.datasourceId}/permissions/revoke`,
          method: 'DELETE',
          body,
        };
      },
      invalidatesTags: ['users'],
    }),
  }),
});

export const {
  useGetInvitesQuery,
  useSendInvitationMutation,
  useRevokeInvitationMutation,
} = inviteApi;
